import { CommonModule, DatePipe } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule, Routes } from '@angular/router';

import { ClaimsDataService } from 'app/commercial/claims/services/claims-data.service';
import { GetClaimsService } from 'app/commercial/claims/services/get-claims.service';
import { IconSvgService } from 'app/commercial/claims/services/icon-svg.service';
import { OmsService } from 'app/commercial/claims/services/oms.service';
import { SearchForClaimsService } from 'app/commercial/claims/services/search-for-claims.service';
// import { RequestCoiDataService } from 'app/commercial/claims/services/';
import { AccountRetrievalService } from 'app/commercial/claims/services/account-retrieval.service';
import { FormatPolicyNumberService } from 'app/commercial/claims/services/format-policy-number.service';
import { PackageService } from 'app/commercial/claims/services/package.service';
import { PolicyInfoService } from 'app/commercial/claims/services/policy-info.service';
import { CommercialClaimsGuard } from 'app/route_guards/commercial-claims.guard';
import { SharedModule } from 'app/shared/shared.module';
import { claimsRoutes } from './claims/claims.routes';
import { ConfirmationComponent } from './claims/confirmation/confirmation.component';
import { AllUpdatesComponent } from './claims/dashboard/claim-overview/all-updates/all-updates.component';
import { ClaimContactsComponent } from './claims/dashboard/claim-overview/claim-contacts/claim-contacts.component';
import { ClaimOverviewComponent } from './claims/dashboard/claim-overview/claim-overview.component';
import { IncidentDetailsComponent } from './claims/dashboard/claim-overview/incident-details/incident-details.component';
import { PaymentsComponent } from './claims/dashboard/claim-overview/payments/payments.component';
import { PAKClaimsListComponent } from './claims/dashboard/pak-claims-list/pak-claims-list.component';
import { PolicySectionComponent } from './claims/dashboard/pak-claims-list/policy-section/policy-section.component';
import { PaginationComponent } from './claims/dashboard/policy-claims-list/pagination/pagination.component';
import { PolicyClaimsListComponent } from './claims/dashboard/policy-claims-list/policy-claims-list.component';
import { SearchClaimComponent } from './claims/dashboard/search-claim/search-claim.component';
import { AggregateLimitsService } from './claims/farm-flex-deductible/aggregate-limits.service';
import { FarmFlexDeductibleComponent } from './claims/farm-flex-deductible/farm-flex-deductible.component';
import { FarmFlexDeductibleService } from './claims/farm-flex-deductible/farm-flex-deductible.service';
import { PolicySummaryService } from './claims/farm-flex-deductible/policy-summary.service';
import { AddressComponent } from './claims/first-notice-of-loss/address/address.component';
import { BusinessAutoComponent } from './claims/first-notice-of-loss/business-auto/business-auto.component';
import { CommercialPropertyComponent } from './claims/first-notice-of-loss/commercial-property/commercial-property.component';
import { FirstNoticeOfLossComponent } from './claims/first-notice-of-loss/first-notice-of-loss.component';
import { FraudLanguageComponent } from './claims/first-notice-of-loss/fraud-language/fraud-language.component';
import { GeneralLiabilityComponent } from './claims/first-notice-of-loss/general-liability/general-liability.component';
import { SubmissionFailedComponent } from './claims/first-notice-of-loss/submission-failed/submission-failed.component';
import { WhatYouCanExpectComponent } from './claims/first-notice-of-loss/what-you-can-expect/what-you-can-expect.component';
import { WorkersCompensationComponent } from './claims/first-notice-of-loss/workers-compensation/workers-compensation.component';

const commercialRoutes: Routes = [
    {
        path: 'commercial',
        children: [
            {
                path: 'claims',
                canActivateChild: [CommercialClaimsGuard],
                children: claimsRoutes
            }
        ]
    }
];

@NgModule({
    declarations: [
        FirstNoticeOfLossComponent,
        GeneralLiabilityComponent,
        WorkersCompensationComponent,
        BusinessAutoComponent,
        CommercialPropertyComponent,
        ConfirmationComponent,
        AddressComponent,
        FraudLanguageComponent,
        WhatYouCanExpectComponent,
        PolicyClaimsListComponent,
        PAKClaimsListComponent,
        PolicySectionComponent,
        ClaimOverviewComponent,
        SearchClaimComponent,
        PaginationComponent,
        AllUpdatesComponent,
        IncidentDetailsComponent,
        ClaimContactsComponent,
        PaymentsComponent,
        SubmissionFailedComponent,
        FarmFlexDeductibleComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        SharedModule,
        MatIconModule,
        MatDialogModule,
        RouterModule.forChild(commercialRoutes)
    ],
    providers: [
        SearchForClaimsService,
        ClaimsDataService,
        GetClaimsService,
        OmsService,
        IconSvgService,
        // RequestCoiDataService,
        AccountRetrievalService,
        PackageService,
        PolicyInfoService,
        FormatPolicyNumberService,
        FarmFlexDeductibleService,
        AggregateLimitsService,
        PolicySummaryService,
        DatePipe,
        CommercialClaimsGuard,
        provideHttpClient(withInterceptorsFromDi())
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class CommercialModule { }
